"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditAction = exports.KDS_TIMER_THRESHOLDS = void 0;
/** Colour thresholds for the KDS timer, in minutes. */
exports.KDS_TIMER_THRESHOLDS = {
    normalMaxMinutes: 10,
    warningMaxMinutes: 20,
};
/** Audited actions. Extend freely; values are stored as plain strings. */
exports.AuditAction = {
    LOGIN: 'LOGIN',
    LOGIN_FAILED: 'LOGIN_FAILED',
    LOGOUT: 'LOGOUT',
    PASSWORD_CHANGED: 'PASSWORD_CHANGED',
    PRICE_CHANGED: 'PRICE_CHANGED',
    PRODUCT_CREATED: 'PRODUCT_CREATED',
    PRODUCT_DELETED: 'PRODUCT_DELETED',
    ORDER_CREATED: 'ORDER_CREATED',
    ORDER_CANCELLED: 'ORDER_CANCELLED',
    ORDER_STATUS_CHANGED: 'ORDER_STATUS_CHANGED',
    PAYMENT_RECEIVED: 'PAYMENT_RECEIVED',
    PAYMENT_REFUNDED: 'PAYMENT_REFUNDED',
    EMPLOYEE_CREATED: 'EMPLOYEE_CREATED',
    EMPLOYEE_DELETED: 'EMPLOYEE_DELETED',
    PERMISSION_CHANGED: 'PERMISSION_CHANGED',
    ROLE_CREATED: 'ROLE_CREATED',
    ROLE_DELETED: 'ROLE_DELETED',
    SHIFT_OPENED: 'SHIFT_OPENED',
    SHIFT_CLOSED: 'SHIFT_CLOSED',
    CASH_HANDOVER_CONFIRMED: 'CASH_HANDOVER_CONFIRMED',
    TENANT_BLOCKED: 'TENANT_BLOCKED',
    TENANT_ACTIVATED: 'TENANT_ACTIVATED',
    SUBSCRIPTION_CHANGED: 'SUBSCRIPTION_CHANGED',
    TELEGRAM_CONFIG_CHANGED: 'TELEGRAM_CONFIG_CHANGED',
    SETTINGS_CHANGED: 'SETTINGS_CHANGED',
};
//# sourceMappingURL=platform.js.map